module.exports = __webpack_public_path__ + "img/04.53e86491.jpg";